import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function FaqSection() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I contact support?",
      answer: "Email us anytime at contact@myhoom.com — we’re here to help.",
    },
    {
      question: "Do I need the app to receive a beer?",
      answer:
        "No app is required — recipients can redeem directly via QR code.",
    },
    {
      question: "What is my HOOM?",
      answer:
        "my HOOM is a digital gifting service that lets you send beers to friends at participating locations.",
    },
  ];

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      style={{
        // 80px each side plus a paddingLeft: 60px override left 250px of a 390px screen for
        // two columns that each declared minWidth: 260px. One clamped value, no override.
        // AC-MOBILE-F1.
        padding: "clamp(56px, 12vw, 120px) clamp(20px, 6vw, 80px)",
        backgroundColor: "#f9f9f9",
        display: "flex",
        justifyContent: "between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "clamp(24px, 5vw, 60px)",
          width: "100%",
        }}
      >
        {/* Left Column */}
        <div
          style={{
            flex: "1 1 300px",
            minWidth: 0,
          }}
        >
          {/* Title with Divider */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "30px",
            }}
          >
            <h2
              style={{
                fontSize: "2rem",
                margin: 0,
                whiteSpace: "nowrap",
              }}
            >
              FAQ
            </h2>
            <div
              style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }}
            ></div>
          </div>

          {/* Contact Us Button */}
          <button
            onClick={() => navigate("/contact")}
            style={{
              marginTop: "100px",
              backgroundColor: "#DE810E",
              color: "white",
              border: "none",
              borderRadius: "30px",
              padding: "12px 24px",
              cursor: "pointer",
              fontWeight: "bold",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            Contact Us
          </button>
        </div>

        {/* Right Column - Expandable Questions */}
        <div
          style={{
            flex: "1 1 300px",
            minWidth: 0,
          }}
        >
          {faqs.map((faq, index) => (
            <div
              key={index}
              style={{
                marginBottom: "25px",
                borderBottom: "1px solid #ddd",
                paddingBottom: "25px",
              }}
            >
              <div
                onClick={() => toggle(index)}
                style={{
                  fontWeight: "500",
                  cursor: "pointer",
                  color: "#333",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "1.05rem",
                }}
              >
                <span>{faq.question}</span>
                <span style={{ fontSize: "1.5rem", lineHeight: "1" }}>
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>
              {openIndex === index && (
                <p
                  style={{
                    marginTop: "15px",
                    color: "#868686",
                    fontSize: "0.95rem",
                    lineHeight: "1.5",
                  }}
                >
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
